export default __webpack_public_path__ + "static/media/marigold.c746f13d.png";